import { Component, Prop } from '@stencil/core';


@Component({
  tag: 'tip-yes-no'
})
export class YesNo {
  @Prop() value: boolean;

  render() {
    return (this.value ? 'Yes': 'No');
  }
}
